<template>
  <div>
    <section class="section has-background-white-ter skewed-background">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column">
            <h1 class="title is-1">NuMRis</h1>
            <h2 class="subtitle is-4">Numerical Magnetic Resonance Implant Safety</h2>
            <p>
              This tool of the InSilicoMRI library allows the investigation of the
              radiofrequency (RF)-induced heating of passive devices in an MRI
              scanner. The simulation steps are designed following the
              ASTM F2182-19e2 Standard.
            </p>
          </div>
          <div class="column">
            <figure class="image">
              <img class="splash" src="insilicomri_521878072_530px_compressed2.jpg" />
            </figure>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-features">
      <div class="container">
        <div class="has-text-centered">
          <h2 class="title is-2">Features</h2>
        </div>
        <div class="columns columns-features">
          <div class="column">
            <div class="card card-same-height">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <span class="icon is-large">
                      <font-awesome-icon icon="file-upload" size="2x" />
                    </span>
                  </div>
                  <div class="media-content">
                    <p>Select a simplified medical device design from the tool library or upload your own device design.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card card-same-height">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <span class="icon is-large">
                      <font-awesome-icon icon="magnet" size="2x" />
                    </span>
                  </div>
                  <div class="media-content">
                    <p>Setup a compatibility test simulation for 1.5T and 3T systems.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card card-same-height">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <span class="icon is-large">
                      <font-awesome-icon icon="temperature-low" size="2x" />
                    </span>
                  </div>
                  <div class="media-content">
                    <p>Collect specific absorption rate (SAR) and temperature results for different exposure setups.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card card-same-height">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <span class="icon is-large">
                      <font-awesome-icon icon="clipboard-check" size="2x" />
                    </span>
                  </div>
                  <div class="media-content">
                    <p>Create a result report following the FDA guidelines for regulatory submissions.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-info is-bold">
      <div class="hero-body">
        <div class="container">
          <p>
            NuMRis was created in collaboration between InSilicoTrials, ANSYS, and FDA, to support the
            broadening use of computer modeling and simulation (CM&S) for electromagnetic safety analysis
            prior to medical device submission.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { login } from '@/lib/iam';

export default {
  mounted() {
    if (this.$route.matched.some((record) => record.meta.registrationFlow)) {
      login();
    }
  },
};
</script>

<style scoped>
h2.subtitle {
  padding-top: 0.25em;
  padding-bottom: 0.5em;
}

.section-features {
  padding-top: 3em;
  padding-bottom: 5em;
  background-color: white;
}

.columns-features {
  margin-top: 2em;
}

.card-same-height {
  height: 100%;
}

.skewed-background {
  position: relative;
  background-color: red;
}

.skewed-background::before {
  position: absolute;
  content: "";
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  clip-path: polygon(100% 60%, 0% 100%, 100% 100%);
}

img.splash {
  height: 22em;
  width: auto;
  margin: auto;
}
</style>
